import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/cambulo",
    name: "Cambulo",
    component: () =>
      import ("../views/Cambulo.vue")
  },
  { path: "*", component: () => import("@/views/Error404") }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;